import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../assets/scss/style.scss";
import Seat from "../components/componentForService/seat";
import ServicePane from "../components/componentForService/servicePane";
import Baggage from "../components/componentForService/baggage";
import { isEmptyObject } from "../helpers/function_helper";

export default function Service() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const location = useLocation();
  const navigate = useNavigate();
  // Get passenger counts from location.state (default to 1 adult if not provided)

  useEffect(() => {
    const isOnResponsePage = localStorage.getItem('isOnResponsePage');
    if (isOnResponsePage === 'true') {
      navigate("/");
    }
  }, []);

  const [passengers, setPassengers] = useState(
    location.state.passengers.map((p) => ({
      ...p,
      hanh_ly: {},
      cho_ngoi: {
        0: {},
        1: {},
      },
      dich_vu: {
        0: {},
        1: {},
      },
    }))
  );

  // Khôi phục dữ liệu service đã chọn nếu có
  useEffect(() => {
    if (location.state?.passengers) {
      setPassengers(location.state.passengers.map((p) => ({
      ...p,
      hanh_ly: p.hanh_ly ? p.hanh_ly : {},
      cho_ngoi: {
        0: p.cho_ngoi && p.cho_ngoi[0] ? p.cho_ngoi[0] : {},
        1: p.cho_ngoi && p.cho_ngoi[1] ? p.cho_ngoi[1] : {},
      },
      dich_vu: {
        0: p.dich_vu && p.dich_vu[0] ? p.dich_vu[0] : {},
        1: p.dich_vu && p.dich_vu[1] ? p.dich_vu[1] : {},
      },
    })));
    }
  }, [location.state?.passengers]);

  const [activeTab, setActiveTab] = useState("hanh_ly");
  const [activeTabChieuVe, setActiveTabChieuVe] = useState("hanh_ly");
  const [services, setServices] = useState({
    chieuDi: {
      hanhLy: {},
      choNgoi: {},
      dichVu: {},
    },
    chieuVe: {
      hanhLy: {},
      choNgoi: {},
      dichVu: {},
    },
  });
  const [showDetail, setShowDetail] = useState({});

  // Hàm helper tách dịch vụ
  const extractServices = (item) => {
    const hanhLy = {};
    const dichVu = {};
    const choNgoi = item.cho_ngoi || {};

    Object.entries(item.dich_vu || {}).forEach(([key, arr]) => {
      hanhLy[key] = arr.filter((i) => i.loai_dich_vu === 2 || i.nhom === "242");
      dichVu[key] = arr.filter((i) => i.loai_dich_vu !== 2 && i.nhom !== "242");
    });

    return { hanhLy, dichVu, choNgoi };
  };

  useEffect(() => {
    if (!location.state?.dsDichVu) return;
    setServices({
      chieuDi: extractServices(
        location.state?.dsDichVu[0] ? location.state?.dsDichVu[0] : {}
      ),
      chieuVe: extractServices(
        location.state?.dsDichVu[1] ? location.state?.dsDichVu[1] : {}
      ),
    });
  }, [location.state?.dsDichVu]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleTabChieuVeClick = (tab) => {
    setActiveTabChieuVe(tab);
  };
  // Handle input change (add accompanyingAdult)
  const handleChangeHanhLy = (idx, field, valueJson, indexChieu) => {
    const newPassengers = [...passengers];
    newPassengers[idx][field][indexChieu] = valueJson ? valueJson : {};
    setPassengers(newPassengers);
  };

  const handleChangeDichVu = (idx, item, valueJson, indexChieu) => {
    const newPassengers = [...passengers];
    newPassengers[idx]["dich_vu"][indexChieu][item] = valueJson
      ? valueJson
      : {};
    setPassengers(newPassengers);
  };

  const handleChangeChoNgoi = (valueJson, indexChieu) => {
    const newPassengers = [...passengers];
    if (
      newPassengers[valueJson.idp]["cho_ngoi"]?.[indexChieu]?.[valueJson.ids]
        ?.uuid === valueJson.dataSeat.uuid
    ) {
      newPassengers[valueJson.idp]["cho_ngoi"][indexChieu][valueJson.ids] = {};
    } else {
      newPassengers[valueJson.idp]["cho_ngoi"][indexChieu][valueJson.ids] =
        valueJson.dataSeat;
    }
    setPassengers(newPassengers);
  };

  const TYPEOF_NAME_OPTIONS = {
    ADULT: [
      { label: "Ông", value: 1 },
      { label: "Bà", value: 3 },
    ],
    CHILD: [
      { label: "Trẻ em trai", value: 4 },
      { label: "Trẻ em gái", value: 5 },
    ],
    INFANT: [
      { label: "Bé trai", value: 6 },
      { label: "Bé gái", value: 7 },
    ],
  };

  return (
    <section id="tour_booking_submission" className="section_padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <div className="tour_details_right_sidebar_wrapper">
              <div className="tour_detail_right_sidebar">
                <div className="tour_details_right_boxed">
                  <div className="tour_details_right_box_heading mb-2">
                    <h3>Thông tin chuyến bay</h3>
                  </div>
                  <div>
                    {(() => {
                      const flights = Array.isArray(location.state?.flight)
                        ? location.state.flight.filter(Boolean)
                        : [location.state?.flight].filter(Boolean);
                      return flights.map((flight, idx) => {
                        // Extract info safely
                        const duration = flight?.thoi_gian_bay || "";
                        const logo = flight?.hang_bay?.logo || "";
                        // Title for direction
                        let directionTitle = "";
                        if (flights.length > 1) {
                          directionTitle = idx === 0 ? "Chiều đi" : "Chiều về";
                        }
                        return (
                          <div
                            key={idx}
                            style={{
                              marginBottom: 16,
                              width: "100%",
                              border: "1px solid #e0e0e0",
                              borderRadius: 8,
                              padding: 16,
                              background: "#f8fbff",
                              boxShadow: "0 2px 8px rgba(25,118,210,0.04)",
                            }}
                          >
                            {directionTitle && (
                              <div
                                style={{
                                  fontWeight: 600,
                                  fontSize: 15,
                                  color: "#1976d2",
                                }}
                              >
                                {directionTitle}
                              </div>
                            )}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 12,
                              }}
                            >
                              {/* Điểm đi */}
                              <div
                                style={{ width: "28%", textAlign: "center" }}
                              >
                                <p
                                  style={{
                                    margin: 0,
                                    color: "#888",
                                    fontSize: 13,
                                  }}
                                >
                                  Điểm đi
                                </p>
                                <h3
                                  style={{
                                    margin: 0,
                                    fontSize: 18,
                                    fontWeight: 600,
                                  }}
                                >
                                  {flight?.diem_di.tinh}
                                </h3>
                                <p>{flight?.diem_di.ma}</p>
                              </div>
                              {/* Logo + duration */}
                              <div
                                style={{ width: "34%", textAlign: "center" }}
                              >
                                {logo && (
                                  <img
                                    src={logo}
                                    alt="logo"
                                    style={{
                                      width: 90,
                                      objectFit: "contain",
                                      marginBottom: 4,
                                    }}
                                  />
                                )}
                                <div
                                  style={{
                                    margin: "6px 0 0 0",
                                    fontWeight: 500,
                                    fontSize: 14,
                                    color: "#333",
                                  }}
                                >
                                  {flight?.so_hieu}
                                </div>
                                <div
                                  style={{
                                    fontSize: 13,
                                    color: "#1976d2",
                                    marginTop: 2,
                                  }}
                                >
                                  {duration}
                                </div>
                              </div>
                              {/* Điểm đến */}
                              <div
                                style={{ width: "28%", textAlign: "center" }}
                              >
                                <p
                                  style={{
                                    margin: 0,
                                    color: "#888",
                                    fontSize: 13,
                                  }}
                                >
                                  Điểm đến
                                </p>
                                <h3
                                  style={{
                                    margin: 0,
                                    fontSize: 18,
                                    fontWeight: 600,
                                  }}
                                >
                                  {flight?.diem_den.tinh}
                                </h3>
                                <p>{flight?.diem_den.ma}</p>
                              </div>
                            </div>
                          </div>
                        );
                      });
                    })()}
                  </div>
                </div>
              </div>

              <div className="tour_detail_right_sidebar">
                <div className="tour_details_right_boxed">
                  <div className="tour_details_right_box_heading">
                    <h3>Thông tin giá vé</h3>
                  </div>
                  <div className="tour_booking_amount_area">
                    <ul>
                      {/* Hiển thị giá từng chiều, từng loại hành khách, từng dịch vụ/sản phẩm */}
                      {(() => {
                        const flights = Array.isArray(location.state?.flight)
                          ? location.state.flight.filter(Boolean)
                          : [location.state?.flight].filter(Boolean);

                        // 0: chiều đi, 1: chiều về
                        return [0, 1].map((chieuIdx) => {
                          if (!flights[chieuIdx]) return null;
                          let directionTitle = "";
                          if (flights.length > 1)
                            directionTitle =
                              chieuIdx === 0 ? "Chiều đi" : "Chiều về";
                          else {
                            directionTitle = "Chiều đi";
                          }
                          // Gom nhóm theo loại hành khách
                          const typeMap = { Adult: [], Child: [], Infant: [] };
                          passengers.forEach((p, idx) => {
                            if (typeMap[p.type])
                              typeMap[p.type].push({ ...p, idx });
                          });
                          // Tổng tiền từng loại (không hiển thị nữa)
                          // const sumByType = ...

                          // Tổng tiền chiều này (vé + dịch vụ + ghế + hành lý)
                          let totalChieu = 0;
                          passengers.forEach((p) => {
                            const fare =
                              flights[chieuIdx]?.tuy_chon_gia_ve_mac_dinh;
                            if (!fare) return;
                            if (p.type === "Adult")
                              totalChieu += fare.nguoi_lon?.gia_dai_ly || 0;
                            if (p.type === "Child")
                              totalChieu += fare.tre_em?.gia_dai_ly || 0;
                            if (p.type === "Infant")
                              totalChieu += fare.em_be?.gia_net || 0;
                            if (p.hanh_ly && p.hanh_ly[chieuIdx])
                              totalChieu += p.hanh_ly[chieuIdx].gia_net || 0;
                            if (p.cho_ngoi && p.cho_ngoi[chieuIdx])
                              Object.values(p.cho_ngoi[chieuIdx]).forEach(
                                (ghe) => (totalChieu += ghe.gia_net || 0)
                              );
                            if (p.dich_vu && p.dich_vu[chieuIdx])
                              Object.values(p.dich_vu[chieuIdx]).forEach(
                                (dv) => (totalChieu += dv.gia_net || 0)
                              );
                          });

                          return (
                            <React.Fragment key={chieuIdx}>
                              <li
                                style={{
                                  fontWeight: 700,
                                  fontSize: 15,
                                  marginTop: chieuIdx > 0 ? 8 : 0,
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>{directionTitle}</span>
                                <span>{totalChieu.toLocaleString()}₫</span>
                              </li>
                              {/* Giá vé máy bay từng loại */}
                              {["Adult", "Child", "Infant"].map((type) =>
                                typeMap[type].length > 0 ? (
                                  <React.Fragment key={type}>
                                    <li style={{ fontWeight: 600 }}>
                                      <span
                                        style={{
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={() =>
                                          setShowDetail((prev) => ({
                                            ...prev,
                                            [chieuIdx + "-" + type]:
                                              !prev?.[chieuIdx + "-" + type],
                                          }))
                                        }
                                      >
                                        {showDetail?.[chieuIdx + "-" + type]
                                          ? "▼"
                                          : "►"}{" "}
                                        {type === "Adult"
                                          ? "Người lớn"
                                          : type === "Child"
                                          ? "Trẻ em"
                                          : "Em bé"}{" "}
                                        x {typeMap[type].length}
                                      </span>
                                    </li>
                                    <li
                                      style={{
                                        fontSize: 13,
                                        color: "#666",
                                        marginLeft: 10,
                                      }}
                                    >
                                      - Giá vé x {typeMap[type].length}:{" "}
                                      {typeMap[type]
                                        .reduce((sum, p) => {
                                          const fare =
                                            flights[chieuIdx]
                                              ?.tuy_chon_gia_ve_mac_dinh;
                                          if (!fare) return sum;
                                          if (type === "Adult")
                                            return (
                                              sum +
                                              (fare.nguoi_lon?.gia_fare || 0)
                                            );
                                          if (type === "Child")
                                            return (
                                              sum + (fare.tre_em?.gia_fare || 0)
                                            );
                                          if (type === "Infant")
                                            return (
                                              sum + (fare.em_be?.gia_fare || 0)
                                            );
                                          return sum;
                                        }, 0)
                                        .toLocaleString()}
                                      ₫ | Thuế Phí x {typeMap[type].length}:{" "}
                                      {typeMap[type]
                                        .reduce((sum, p) => {
                                          const fare =
                                            flights[chieuIdx]
                                              ?.tuy_chon_gia_ve_mac_dinh;
                                          if (!fare) return sum;
                                          if (type === "Adult")
                                            return (
                                              sum +
                                              (fare.nguoi_lon?.thue + fare.nguoi_lon?.phi_dai_ly || 0)
                                            );
                                          if (type === "Child")
                                            return (
                                              sum +
                                              (fare.tre_em?.thue + fare.tre_em?.phi_dai_ly || 0)
                                            );
                                          if (type === "Infant")
                                            return (
                                              sum +
                                              (fare.em_be?.thue || 0)
                                            );
                                          return sum;
                                        }, 0)
                                        .toLocaleString()}
                                      ₫ | Dịch vụ:{" "}
                                      {typeMap[type]
                                        .reduce((sum, p) => {
                                          let serviceTotal = 0;
                                          // Tính tổng tiền hành lý
                                          if (p.hanh_ly && p.hanh_ly[chieuIdx]) {
                                            serviceTotal += p.hanh_ly[chieuIdx].gia_net || 0;
                                          }
                                          // Tính tổng tiền chỗ ngồi
                                          if (p.cho_ngoi && p.cho_ngoi[chieuIdx]) {
                                            Object.values(p.cho_ngoi[chieuIdx]).forEach(
                                              (ghe) => {
                                                serviceTotal += ghe.gia_net || 0;
                                              }
                                            );
                                          }
                                          // Tính tổng tiền dịch vụ khác
                                          if (p.dich_vu && p.dich_vu[chieuIdx]) {
                                            Object.values(p.dich_vu[chieuIdx]).forEach(
                                              (dv) => {
                                                serviceTotal += dv.gia_net || 0;
                                              }
                                            );
                                          }
                                          return sum + serviceTotal;
                                        }, 0)
                                        .toLocaleString()}
                                      ₫
                                    </li>
                                    {showDetail?.[chieuIdx + "-" + type] &&
                                      typeMap[type].map((p, idxP) => (
                                        <ul
                                          key={p.idx + "-detail"}
                                          style={{
                                            marginLeft: 20,
                                            marginBottom: 4,
                                          }}
                                        >
                                          <li
                                            style={{
                                              fontWeight: 500,
                                              fontSize: 13,
                                            }}
                                          >
                                            {p.name}
                                          </li>
                                          {/* Hành lý */}
                                          {p.hanh_ly && p.hanh_ly[chieuIdx] && p.hanh_ly[chieuIdx].uuid && (
                                            <li
                                              style={{
                                                fontSize: 13,
                                                color: "#666",
                                              }}
                                            >
                                              Hành lý:{" "}
                                              {p.hanh_ly[chieuIdx]
                                                .ten_hien_thi ||
                                                p.hanh_ly[chieuIdx].ten}{" "}
                                              <span>
                                                {(
                                                  p.hanh_ly[chieuIdx].gia_net ||
                                                  0
                                                ).toLocaleString()}
                                                ₫
                                              </span>
                                            </li>
                                          )}
                                          {/* Ghế */}
                                          {p.cho_ngoi &&
                                            p.cho_ngoi[chieuIdx] &&
                                            Object.values(
                                              p.cho_ngoi[chieuIdx]
                                            ).map((ghe, gidx) =>
                                              ghe && ghe.ma_ghe ? (
                                                <li
                                                  key={gidx + "-ghe"}
                                                  style={{
                                                    fontSize: 13,
                                                    color: "#666",
                                                  }}
                                                >
                                                  Ghế: {ghe.ma_ghe}{" "}
                                                  <span>
                                                    {(
                                                      ghe.gia_net || 0
                                                    ).toLocaleString()}
                                                    ₫
                                                  </span>
                                                </li>
                                              ) : null
                                            )}
                                          {/* Dịch vụ khác */}

                                         
                                          {p.dich_vu &&
                                            p.dich_vu[chieuIdx] &&
                                            Object.values(
                                              p.dich_vu[chieuIdx]
                                            ).map((dv, didx) =>
                                              dv && dv.ten ? (
                                                <li
                                                  key={didx + "-dv"}
                                                  style={{
                                                    fontSize: 13,
                                                    color: "#666",
                                                  }}
                                                >
                                                  Dịch vụ:{" "}
                                                  {dv.ten_hien_thi || dv.ten}{" "}
                                                  <span>
                                                    {(
                                                      dv.gia_net || 0
                                                    ).toLocaleString()}
                                                    ₫
                                                  </span>
                                                </li>
                                              ) : null
                                            )}
                                        </ul>
                                      ))}
                                  </React.Fragment>
                                ) : null
                              )}
                            </React.Fragment>
                          );
                        });
                      })()}
                    </ul>
                    <div className="tour_bokking_subtotal_area">
                      {/* Tổng tiền tất cả các chiều, gồm vé + dịch vụ + ghế + hành lý */}
                      {(() => {
                        const flights = Array.isArray(location.state?.flight)
                          ? location.state.flight.filter(Boolean)
                          : [location.state?.flight].filter(Boolean);
                        let total = 0;
                        [0, 1].forEach((chieuIdx) => {
                          if (!flights[chieuIdx]) return;
                          passengers.forEach((p) => {
                            const fare =
                              flights[chieuIdx]?.tuy_chon_gia_ve_mac_dinh;
                            if (!fare) return;
                            if (p.type === "Adult")
                              total += fare.nguoi_lon?.gia_dai_ly || 0;
                            if (p.type === "Child")
                              total += fare.tre_em?.gia_dai_ly || 0;
                            if (p.type === "Infant")
                              total += fare.em_be?.gia_net || 0;
                            if (p.hanh_ly && p.hanh_ly[chieuIdx])
                              total += p.hanh_ly[chieuIdx].gia_net || 0;
                            if (p.cho_ngoi && p.cho_ngoi[chieuIdx])
                              Object.values(p.cho_ngoi[chieuIdx]).forEach(
                                (ghe) => (total += ghe.gia_net || 0)
                              );
                            if (p.dich_vu && p.dich_vu[chieuIdx])
                              Object.values(p.dich_vu[chieuIdx]).forEach(
                                (dv) => (total += dv.gia_net || 0)
                              );
                          });
                        });
                        return (
                          <h6 style={{ fontWeight: 700 }}>
                            Tổng cộng <span>{total.toLocaleString()}₫</span>
                          </h6>
                        );
                      })()}
                    </div>
                    {/* Có thể bổ sung code cho coupon hoặc discount nếu cần */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="tou_booking_form_Wrapper">
              <div className="booking_tour_form">
                <div className="tour_booking_form_box">
                   <h3 className="heading_theme" style={{fontSize: "22px", marginBottom: "0px"}}>Dịch vụ {location.state?.flight[1] ? " chiều đi" : ""}</h3>
                  <div className="row">
                    <div className="col-lg-12">
                      <div
                        //   className="flight_categories_search"
                        style={{ position: "static" }}
                      >
                        <Baggage
                          services={services}
                          passengers={passengers}
                          handleChangeHanhLy={handleChangeHanhLy}
                           handleChangeDichVu={handleChangeDichVu}
                          indexChieu={0}
                        />
                        {/* <ServicePane
                          services={services}
                          passengers={passengers}
                          handleChangeDichVu={handleChangeDichVu}
                          indexChieu={0}
                        /> */}
                      </div>
                    </div>
                  </div>
                </div>
                {location.state?.flight[1] ? (
                  <>
                    <div className="tour_booking_form_box mt-3">
                        <h3 className="heading_theme" style={{fontSize: "22px", marginBottom: "0px"}}>Dịch vụ chiều về</h3>
                      <div className="row">
                        <div className="col-lg-12">
                          <div
                            //   className="flight_categories_search"
                            style={{ position: "static" }}
                          >
                            <Baggage
                              services={services}
                              passengers={passengers}
                              handleChangeHanhLy={handleChangeHanhLy}
                              handleChangeDichVu={handleChangeDichVu}
                              indexChieu={1}
                            />
                            {/* <ServicePane
                              services={services}
                              passengers={passengers}
                              handleChangeDichVu={handleChangeDichVu}
                              indexChieu={1}
                            /> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-secondary"
                    style={{minWidth: 150}}
                    onClick={() => {
                      navigate("/thong-tin-hanh-khach", {
                        state: {
                          passengers: location.state?.passengers,
                          flight: location.state?.flight,
                          contact: location.state?.contact,
                          isReturn: true
                        },
                      });
                    }}
                  >
                    Quay lại
                  </button>
                  <button
                    className="btn btn-primary ms-2"
                    style={{
                      minWidth: 150,
                      fontWeight: 600,
                      padding: "12px 24px",
                      borderRadius: 8,
                      boxShadow: "0 2px 8px rgba(25,118,210,0.15)",
                    }}
                    onClick={() => {
                      navigate("/thong-tin-thanh-toan", {
                        state: {
                          passengers,
                          flight: location.state?.flight,
                          contact: location.state?.contact,
                          dsDichVu: location.state?.dsDichVu || {}
                        },
                      });
                    }}
                  >
                    Tiếp tục
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
